import { render, staticRenderFns } from "./PriceGrid.vue?vue&type=template&id=2558eede"
import script from "./PriceGrid.vue?vue&type=script&lang=js"
export * from "./PriceGrid.vue?vue&type=script&lang=js"
import style0 from "./PriceGrid.vue?vue&type=style&index=0&id=2558eede&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports